
/**
 * 预览接口sdk
 * @param {function} successCallback 预览成功的回调函数;
 *                                   参数：url(预览地址)，data(ajax数据对象)
 * @param {function} errorCallback 预览失败的回调函数;
 *                                  参数：data(ajax数据对象)
 */
export default function PreviewHandler(successCallback, errorCallback, progressCallback) {
  this.successCallback = successCallback
  this.errorCallback = errorCallback
  this.progressCallback = progressCallback
  // 用来寄存每次自定义的回调函数，当自定义函数存在时，不会执行初始化的回调函数
  this._progressCallback = null
  // 用来存文件转换时的定时器
  this.progress = null
  this.progressData = null
  // 定时器间隔暂时定为3000毫秒
  this.delta = 3000
  // 初始化存放xhr数组, 用于abort
  this.xhrBox = []
  this.getInterval = true
}

PreviewHandler.prototype = {
  // 判断字符串能不能转换json，不能就返回''
  _getJsonStr(str) {
    try {
      const temp = JSON.parse(str)
    } catch (e) {
      str = ''
    }
    return str
  },
  /**
     * 发送ajax，之后这个方法可以替代成axios或者fetch
     * @param {str} url ajax请求url
     * @param {str} methods ajax请求方式(大写GET，POST)
     * @param {object} options
     *        {
     *              successCalback成功的回调函数，接收参数请求到的json字符串
     *              failedCallback失败的回调函数，接收参数请求到的json字符串和状态码
     *         }
     */
  ajax(url, methods, options) {
    const { successCalback } = options
    const { failedCallback } = options
    const context = options.context || this
    const xhr = new XMLHttpRequest()
    const self = this
    xhr.open(methods, url)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        let resobj
        if (typeof xhr.responseText === 'string') {
          if (self._getJsonStr(xhr.responseText) != '') {
            resobj = JSON.parse(self._getJsonStr(xhr.responseText))
          } else {
            resobj = self._getJsonStr(xhr.responseText)
          }
        } else {
          resobj = ''
        }
        if (xhr.status === 200) {
          successCalback && successCalback.call(context, resobj)
        } else {
          failedCallback && failedCallback.call(context, resobj, xhr.status)
        }
      }
    }
    xhr.send()
    options.context.xhrBox.push(xhr)
  },
  /**
     * abort all requests
     */
  abortAll() {
    if (!this.xhrBox) return
    this.xhrBox.forEach((xhr) => {
      xhr.abort()
    })
  },
  /**
     * 有可能需要获取cookie的情况，目前暂时没有用到
     * @param {string} name
     */
  getCookie(name) {
    let arr; const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
    arr = document.cookie.match(reg)
    if (arr) return decodeURI(arr[2])
    return null
  },
  // 停止转换进度
  stopProgress() {
    if (this.progress) {
      clearInterval(this.progress)
      this.progress = null
      if (this._progressCallback) {
        this._progressCallback(this.progressData, this.delta)
      } else if (this.progressCallback) {
        this.progressCallback(this.progressData, this.delta)
      }
      this._progressCallback = null
      this.progressData = null
    }
  },
  /**
     * 第一步，router接口返回url，请求url获取预览探测地址
     * @param {object} data metadata数据
     */
  before(data) {
    // 初始化xhrBox
    this.xhrBox = []
    const url = data.stat_url
    // console.log('_before', data);
    this.ajax(url, 'GET', {
      context: this,
      successCalback: this.medium,
      failedCallback: this.error,
    })
  },

  /**
     * 第二步，预览探测，
     * 1：探测预览文件是否已生成，否则发起文件转换
     * 2：返回的结果和返回的预览地址来完成预览
     * @param {object} data 第一步取到的探测相关数据
     */
  medium(data) {
    const url = `${data.stat_url}&timestamp=${Math.random()}`
    // console.log('_medium', data);
    this.progressData = data
    this.ajax(url, 'GET', {
      context: this,
      successCalback: this.after,
      failedCallback: this.error,
    })
  },
  // 重置私有回调函数
  _resetPraviteCallback() {
    this._successCallback = null
    this._errorCallback = null
    this._progressCallback = null
  },
  /**
     * 第三步，预览实现，通过上边获取到的url进行预览
     * @param {object} data 探测过后获取的预览数据
     */
  after(data) {
    const { result } = data
    const url = data.stat_url
    const self = this
    data.preview_type = self.progressData.preview_type ? self.progressData.preview_type : ''
    // 1211增加文件类型，之前外面的逻辑是根据当前文件去取他的文件类型
    data.file_type = self.progressData.file_type ? self.progressData.file_type : ''
    if (result === 'success') {
      if (this._successCallback) {
        this._successCallback(data)
        this._resetPraviteCallback()
      } else if (this.successCallback) {
        this.successCallback(data)
        clearInterval(this.progress)
      }
    } else if (result === 'converting') {
      self.progressData.result = 'converting'
      if (!this.progress) {
        this.progress = setInterval(() => {
          if (!this.getInterval) {
            clearInterval(this.progress)
            return
          }
          if (self._progressCallback) {
            self._progressCallback(self.progressData, self.delta)
          } else if (self.progressCallback) {
            self.progressCallback(self.progressData, self.delta)
          }
          if (self.progressData) {
            self.medium(self.progressData)
          }
        }, this.delta)
      }
    } else if (result == 'fail') {
      this.stopProgress()
      if (this._errorCallback) {
        this._errorCallback(data)
        this._resetPraviteCallback()
      } else if (this.errorCallback) {
        this.errorCallback(data)
      }
    }
  },
  // 暂时共用一个回调函数
  // data是ajax返回的数据对象
  // status是状态码
  error(data, status) {
    console.warn(data, status)
    const { message } = data
    if (status === 0) { return }
    this.stopProgress()
    if (this._errorCallback) {
      this._errorCallback()
      this._resetPraviteCallback()
    } else if (this.errorCallback) {
      this.errorCallback(data)
    } else {
      alert(message)
    }
  },
  toggleSetInterval(val) {
    this.getInterval = val
  },
}
